import { call } from 'redux-saga/effects';

const initReCAPTCHAScript = async () => {
    await new Promise((resolve, reject) => {
        if (!window.grecaptcha) {
            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/enterprise.js';
            script.async = true;
            script.defer = true;
            script.onload = () => {
                window.grecaptcha.enterprise.ready(() => {
                    resolve();
                });
            };
            script.onerror = () => {
                reject(new Error('Unable to load reCAPTCHA'));
            };
            document.head.appendChild(script);
        } else if (window.grecaptcha.enterprise) {
            window.grecaptcha.enterprise.ready(() => {
                resolve();
            });
        } else {
            reject(new Error('reCAPTCHA is not loaded'));
        }
    });

    if (!document.getElementById('recaptcha_container_score')) {
        const div = document.createElement('div');
        div.id = 'recaptcha_container_score';
        div.style.display = 'none';
        document.body.appendChild(div);
    }
};

function* getReCAPTCHAToken(actionName, recaptchaSiteKey) {
    if (!recaptchaSiteKey) {
        return {};
    }

    yield call(initReCAPTCHAScript);

    const div = document.getElementById('recaptcha_container_score');
    const widgetId = window.grecaptcha.enterprise.render(div, {
        sitekey: recaptchaSiteKey,
        size: 'invisible',
    });

    const recaptchaToken = yield call(window.grecaptcha.enterprise.execute, widgetId, { action: actionName });

    window.grecaptcha.enterprise.reset(widgetId);
    document.body.removeChild(div);

    return {
        recaptchaSiteKey,
        recaptchaToken,
    };
}

export default getReCAPTCHAToken;
